export const createCsv = function(source) {
    const filename = source.fileName;
    const contentType = 'text/csv;charset=utf-8;';
    try {
        const linkElement = document.createElement('a');
        const bom = "\uFEFF";
        const blob = new Blob([bom, source.file], {type: contentType});

        if (navigator.msSaveBlob || navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            let url = window.URL.createObjectURL(blob);
            linkElement.setAttribute('href', url);
            linkElement.setAttribute("download", filename);
        }

        const clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": false
        });

        linkElement.dispatchEvent(clickEvent);
        console.log('success');

    } catch (error) {
        console.error(error);
    }
}


// WEBPACK FOOTER //
// ./src/helpers/createCsv.js